import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaArrowRight, FaPercent, FaBolt } from 'react-icons/fa';

const PromotionalBanner = () => {
  return (
    <section className="py-16">
      <div className="container-custom">
        <div className="grid md:grid-cols-2 gap-6">
          {/* Banner 1 — Summer Sale */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-rose-500 via-pink-600 to-purple-700 p-8 md:p-10 text-white group hover:shadow-2xl hover:shadow-rose-500/20 transition-shadow duration-500"
          >
            <div className="relative z-10">
              <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm rounded-full px-4 py-1.5 text-sm font-medium mb-4">
                <FaPercent className="text-xs" /> Limited Time Offer
              </div>
              <h3 className="text-3xl md:text-4xl font-bold mb-3 leading-tight">
                Summer<br />Sale
              </h3>
              <p className="text-white/80 mb-6 text-lg">Up to 50% off on selected items</p>
              <Link to="/products" className="inline-flex items-center gap-2 bg-white text-rose-600 px-6 py-3 rounded-full font-semibold hover:bg-rose-50 transition-all duration-300 shadow-lg group-hover:shadow-xl">
                Shop Now <FaArrowRight className="group-hover:translate-x-1 transition-transform" />
              </Link>
            </div>
            {/* Decorative orbs */}
            <div className="absolute -right-8 -top-8 w-40 h-40 bg-white/10 rounded-full group-hover:scale-110 transition-transform duration-700" />
            <div className="absolute right-16 -bottom-6 w-28 h-28 bg-white/10 rounded-full group-hover:scale-110 transition-transform duration-700 delay-100" />
            <div className="absolute left-1/2 top-0 w-64 h-64 bg-white/5 rounded-full -translate-x-1/2 -translate-y-1/2" />
          </motion.div>

          {/* Banner 2 — New Arrivals */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-blue-600 via-indigo-600 to-violet-700 p-8 md:p-10 text-white group hover:shadow-2xl hover:shadow-blue-500/20 transition-shadow duration-500"
          >
            <div className="relative z-10">
              <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm rounded-full px-4 py-1.5 text-sm font-medium mb-4">
                <FaBolt className="text-xs" /> Just Dropped
              </div>
              <h3 className="text-3xl md:text-4xl font-bold mb-3 leading-tight">
                Latest<br />Smartphones
              </h3>
              <p className="text-white/80 mb-6 text-lg">Get the newest models with warranty</p>
              <Link to="/products?sortBy=newest" className="inline-flex items-center gap-2 bg-white text-indigo-600 px-6 py-3 rounded-full font-semibold hover:bg-indigo-50 transition-all duration-300 shadow-lg group-hover:shadow-xl">
                View All <FaArrowRight className="group-hover:translate-x-1 transition-transform" />
              </Link>
            </div>
            <div className="absolute -right-6 -bottom-6 w-44 h-44 bg-white/10 rounded-full group-hover:scale-110 transition-transform duration-700" />
            <div className="absolute left-8 -top-4 w-20 h-20 bg-white/10 rounded-full group-hover:scale-110 transition-transform duration-700 delay-100" />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default PromotionalBanner;